import React, { useEffect, useState } from "react";
import InvoicePayors from "./invoice-payors";
import { sunboundPayProxy } from '@proxies';
import { useSpinnerContext } from '@contexts';
import { useLocation, useNavigate } from "react-router-dom";
import { helpers } from "@shared";

const StepEnrollmentPayors = () => {

    const { setSpinnerShow } = useSpinnerContext();
    const [accountPayors, setAccountPayors] = useState(null);
    const navigate = useNavigate(), location = useLocation();
    const {
        state: {
            invoice,
            invoicePayors,
            idProductType,
            account
        }
    } = location;
    const { idAccount } = account;

    useEffect(() => {
        (async () => {
            setSpinnerShow(true);
            try {
                const response = await sunboundPayProxy.getAccountPayors(idAccount);
                setAccountPayors(response);
            } catch (error) {
                // setError(`Unable to process request`);
            }
            setSpinnerShow(false);
        })();
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const done = (invoicePayors) => {
        helpers.navigateNext(location, navigate, undefined, { invoicePayors });
    };

    //TODO: redesign to prevent prop drilling
    return (
        <>
            {
                accountPayors != null &&
                <InvoicePayors done={done} accountPayors={accountPayors} invoice={invoice} invoicePayors={invoicePayors} idProductType={idProductType} account={account} />
            }
        </>
    );
};

export default StepEnrollmentPayors;
